import moment from "moment"
import { GetReturnOrderQuery, ReturnOrder } from "src/graphql/quark/quark.type"
import { ReturnOrderReceiptDataProps } from "."

// export interface MappedReturnOrderReceiptData {
//   items: { name: string; quantity: number; total: number }[]
//   orderNumber?: string | undefined
//   orderType: string
//   cashierName?: string | undefined
//   total: number
//   paymentMethod?: ReturnOrderPaymentMethod
//   orderDate?: string
// }

export const mapReturnOrderToReceiptData = (returnOrderData: ReturnOrder): ReturnOrderReceiptDataProps => {
  const buildCashierName = () => {
    const first = returnOrderData?.locationRegisterSession?.openedBy?.firstName?.trim() || ""
    const last = returnOrderData?.locationRegisterSession?.openedBy?.lastName?.trim() || ""
    return [first, last].filter(Boolean).join(" ") || undefined
  }

  const items = (returnOrderData?.items || []).map((it) => {
    return {
      name: it?.name,
      quantity: it?.quantity || 0,
      total: it?.totalPrice || 0
    }
  })

  return {
    orderNumber: returnOrderData?.secondaryId ? String(returnOrderData?.secondaryId) : undefined,
    orderType: "Return",
    cashierName: buildCashierName(),
    items,
    total: returnOrderData?.totalAmount || 0,
    paymentMethod: returnOrderData?.paymentMethod || undefined,
    orderDate: moment(returnOrderData?.createdAt).format("DD/MM/YYYY") || undefined,
    customerName: returnOrderData?.customer?.name,
    customerPhone: returnOrderData?.customer?.phoneNumber || undefined,
    locationName: returnOrderData?.location?.name
  }
}
export const mapReturnOrderQueryToReceiptData = (
  returnOrderData: GetReturnOrderQuery["getReturnOrder"]
): ReturnOrderReceiptDataProps => {
  const buildCashierName = () => {
    const first = returnOrderData?.locationRegisterSession?.openedBy?.firstName?.trim() || ""
    const last = returnOrderData?.locationRegisterSession?.openedBy?.lastName?.trim() || ""
    return [first, last].filter(Boolean).join(" ") || undefined
  }

  const items = (returnOrderData?.items || []).map((it) => {
    return {
      name: it?.name,
      quantity: it?.quantity || 0,
      total: it?.totalPrice || 0
    }
  })

  return {
    orderNumber: returnOrderData?.secondaryId ? String(returnOrderData?.secondaryId) : undefined,
    orderType: "Return",
    cashierName: buildCashierName(),
    items,
    total: returnOrderData?.totalAmount || 0,
    paymentMethod: returnOrderData?.paymentMethod || undefined,
    orderDate: moment(returnOrderData?.createdAt).format("DD/MM/YYYY") || undefined,
    locationName: returnOrderData?.location?.name,
    customerName: returnOrderData?.customer?.name,
    fbrInvoiceId: returnOrderData?.integrationConfigs?.[0]?.apiResponseId,
    integrations: returnOrderData?.integrationConfigs?.map((it) => ({
      name: it?.name,
      charges: it?.charges || 1
    }))

    // fbrInvoiceId: returnOrderRespData?.fbrInvoiceNo,
    // logo: authConfig?.logo,
    // websiteUrl: authConfig?.website ?? undefined,
    // companyName: authConfig?.name,
  }
}
